import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, menus } from 'config/config'; // Importing configuration settings

/**
 * FilterMenuView class extends JetView to create a filter menu interface.
 */
export default class FilterMenuView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        const left = {
            margin: 10,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for URL
                            name: 'Url',
                            label: "<span class='icon-file-text1'></span>" + _('Url'),
                            labelPosition: 'top',
                            placeholder: _('Url'),
                        },
                        {
                            view: 'combo', // Combo box for selecting parent menu
                            name: 'FatherMenu',
                            minWidth: 200,
                            id: 'FatherMenuF',
                            label: _('Menú Padre'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                        },
                        {
                            view: 'text', // Text input for order
                            name: 'Order',
                            type: 'number',
                            label: _('Orden'),
                            labelPosition: 'top',
                            placeholder: _('Orden'),
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the left section with inputs
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 2 }, // Gravity for layout adjustment
                        {
                            minWidth: 200,
                            view: 'button', // Button to create menu
                            value: _('Crear Menú'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('createMenu:button', [[]]); // Event to create menu
                            },
                        },
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('menu:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to create menu in second section
                            value: _('Crear Menú'),
                            type: 'form',
                            click: () => {
                                this.app.callEvent('createMenu:button', [[]]); // Event to create menu
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear second form
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').setValues(
                                    $$('myForm2').getCleanValues(), // Reset form values
                                );
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter in second section
                            value: _('Consultar'),
                            hotkey: 'enter', // Hotkey for consult action
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get form values
                                this.app.callEvent('menu:filter', [filterdata]); // Trigger filter event
                                $$('filterPopup').hide(); // Hide the popup after consultation
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for collapsible sections
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters section
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the accordion
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };

        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon', // Close icon for popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });

        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for main form
            },
        };
    }
}

// FILE DOCUMENTED
